import { logger } from '../../../../utils/logger';

export function configureAudioCodesForFasterICE(): void {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const globalWindow = window as any;

  const DEFAULT_ICE_TIMEOUT = 1;
  const envIce = Number(process.env.REACT_APP_ICE_TIMEOUT_MS);
  const OPTIMIZED_ICE_TIMEOUT =
    Number.isFinite(envIce) && envIce >= 0 ? envIce : DEFAULT_ICE_TIMEOUT;

  const applyOptimization = () => {
    const audioCode = globalWindow.__voiceClient?.webRtcService?.audioCode;

    if (audioCode?.modes) {
      if (audioCode.modes.ice_timeout_fix !== OPTIMIZED_ICE_TIMEOUT) {
        const originalTimeout = audioCode.modes.ice_timeout_fix;
        audioCode.modes.ice_timeout_fix = OPTIMIZED_ICE_TIMEOUT;
        logger.debug(
          `[CXone SDK] AudioCodes ice_timeout_fix: ${originalTimeout}ms -> ${OPTIMIZED_ICE_TIMEOUT}ms (env REACT_APP_ICE_TIMEOUT_MS=${
            process.env.REACT_APP_ICE_TIMEOUT_MS ?? 'unset'
          })`
        );

        if (typeof audioCode.setModes === 'function') {
          audioCode.setModes({ ice_timeout_fix: OPTIMIZED_ICE_TIMEOUT });
        }

        if (audioCode.pcConfig) {
          audioCode.pcConfig.iceCandidatePoolSize = 1;
          logger.debug('[CXone SDK] Set iceCandidatePoolSize to 1');
        }
        return true;
      }
    }
    return false;
  };

  try {
    if (applyOptimization()) {
      logger.debug('[CXone SDK] ICE optimization applied immediately');
    } else {
      logger.debug('[CXone SDK] AudioCodes not ready yet, will retry...');
    }

    const checkInterval = setInterval(() => {
      if (applyOptimization()) {
        clearInterval(checkInterval);
        logger.debug('[CXone SDK] ICE optimization applied successfully');
      }
    }, 100);

    setTimeout(() => {
      clearInterval(checkInterval);
    }, 10000);

    logger.debug('[CXone SDK] ICE optimization scheduled');
  } catch (error) {
    logger.warn('[CXone SDK] Failed to configure AudioCodesUA modes:', error);
  }
}
